import axios from 'axios'

// 桌面专用构建(VITE_DESKTOP=1):401 时自动续游客会话,不跳登录页
const DESKTOP = import.meta.env.VITE_DESKTOP === '1'

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, '')
}

// 动态判断 baseURL。生产部署和本地调试都可以通过 VITE_API_URL 明确指定后端地址。
export const getApiBaseUrl = () => {
  const configured = import.meta.env.VITE_API_URL?.trim()
  if (configured) {
    return trimTrailingSlash(configured)
  }

  if (window.location.protocol === 'http:' ||
      window.location.protocol === 'https:') {
    return trimTrailingSlash(window.location.origin)
  }

  return 'http://127.0.0.1:3001'
}

export function apiPath(path: string) {
  if (/^(https?:|data:|blob:)/i.test(path)) {
    return path
  }

  const base = getApiBaseUrl()
  const suffix = path.startsWith('/') ? path : `/${path}`
  return `${base}${suffix}`
}

export const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const ENABLE_API_DEBUG = false

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    if (ENABLE_API_DEBUG) {
      console.log('[API请求]', config.method?.toUpperCase(), config.url)
    }
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    if (ENABLE_API_DEBUG) {
      console.log('[API响应]', response.config.url,
        response.status, '数据条数:',
        response.data?.data?.length ?? '未知')
    }
    return response
  },
  async (error) => {
    console.error('[API错误]', error.config?.url,
      error.message, error.response?.status)
    if (error.response?.status === 401) {
      localStorage.removeItem('token')

      if (DESKTOP) {
        // 桌面端:游客 token 过期时重新获取并重试一次,避免打断使用
        const config = error.config as (typeof error.config & { _retry?: boolean })
        if (config && !config._retry) {
          config._retry = true
          try {
            const response = await fetch('/api/v1/auth/desktop', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: '{}',
            })
            const json = await response.json()
            if (json.success && json.data?.token) {
              localStorage.setItem('token', json.data.token)
              // 游客续期时同步补齐用户 id,否则"我的配方"列表查不到(后端 userId 过滤为空)
              localStorage.setItem('perfume_user_id', json.data.user?.id || '00000000-0000-0000-0000-000000000001')
              config.headers.Authorization = `Bearer ${json.data.token}`
              return api(config)
            }
          } catch {
            // 后端未就绪:不重试,保持无 token
          }
        }
      } else {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api
